import React, { useState, useEffect } from "react";
import * as ReactDOM from "react-dom";
import { Button } from "@progress/kendo-react-buttons";
import { Checkbox } from "@progress/kendo-react-inputs";
import { useSelector } from "react-redux";
import {
  updateDataTypesParams,
  getDataTypesSelector,
  initialState,
} from "../Slices/DataTypesSlice";
import { useAppDispatch } from "../../Core/store.hooks";

function DataTypesFilter() {
  const [triggers, setTriggers] = useState<boolean>(initialState.triggers);
  const [alarms, setAlarms] = useState<boolean>(initialState.alarms);
  const [manualOperations, setManualOperations] = useState<boolean>(
    initialState.manualOperations
  );
  // const [cameraRecordEvents, setCameraRecordEvents] = useState<boolean>(
  //   initialState.cameraRecordEvents
  // );
  const dispatch = useAppDispatch();

  const dataTypesFilter = useSelector(getDataTypesSelector);

  useEffect(() => {
    setTriggers(dataTypesFilter.triggers);
    setAlarms(dataTypesFilter.alarms);
    // setCameraRecordEvents(dataTypesFilter.cameraRecordEvents);
    setManualOperations(dataTypesFilter.manualOperations);
  }, [dataTypesFilter]);

  const handleAlarmsChange = (e: any): void => {
    const { value, checked } = e.target;
    setAlarms(value);
  };

  const handleTriggersChange = (e: any): void => {
    const { value } = e.target;
    setTriggers(value);
  };

  const handleManualOperationsChange = (e: any): void => {
    const { value } = e.target;
    setManualOperations(value);
  };

  // const handleCameraRecordEventsChange = (
  //   e: React.SyntheticEvent<EventTarget>
  // ): void => {
  //   const { value } = e.target;
  //   setCameraRecordEvents(value);
  // };

  const paramsHandler = () => {
    let params: {
      alarms: boolean;
      triggers: boolean;
      manualOperations: boolean;
    } = JSON.parse(JSON.stringify(initialState));
    params.alarms = alarms;
    params.triggers = triggers;
    params.manualOperations = manualOperations;
    // params.cameraRecordEvents = cameraRecordEvents;
    dispatch<any>(updateDataTypesParams(params));
  };

  return (
    <div>
      <React.Fragment key="0">
        <Checkbox
          name="alarms"
          checked={alarms}
          defaultChecked={initialState.alarms}
          onChange={handleAlarmsChange}
          label={"Alarms"}
        />
        <br />
      </React.Fragment>

      <React.Fragment key="1">
        <Checkbox
          name="triggers"
          checked={triggers}
          defaultChecked={initialState.triggers}
          onChange={handleTriggersChange}
          label={"Triggers"}
        />
        <br />
      </React.Fragment>

      <React.Fragment key="2">
        <Checkbox
          name="manualOperations"
          checked={manualOperations}
          defaultChecked={initialState.manualOperations}
          onChange={handleManualOperationsChange}
          label={"Manual Operations"}
        />
        <br />
      </React.Fragment>

      {/* <React.Fragment key="3">
        <Checkbox
          name="cameraRecordEvents"
          checked={cameraRecordEvents}
          defaultChecked={initialState.cameraRecordEvents}
          onChange={handleCameraRecordEventsChange}
          label={"Camera Record Events"}
        />
        <br />
      </React.Fragment> */}

      <Button className="pp-filter-button" onClick={() => paramsHandler()}>
        UPDATE
      </Button>
    </div>
  );
}

export default DataTypesFilter;
